import { useState } from "react";
import { Copy } from "lucide-react";

export const CopyNameButton = ({ display, first, onCopy, testid }) => {
  const [ask, setAsk] = useState(false);
  const d = (display || "").trim().slice(0, 80);
  const f = (first || "").trim();
  const copy = () => { onCopy(d); setAsk(false); };
  if (ask) {
    return (
      <div data-testid={`${testid}-confirm`} role="alert" className="flex flex-wrap items-center gap-2 rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-900">
        <span className="min-w-0 flex-1 break-words">Replace "{f}" with "{d}"?</span>
        <button type="button" data-testid={`${testid}-replace`} onClick={copy} className="min-h-[40px] rounded-lg bg-slate-900 px-3 text-xs font-semibold text-white">Replace</button>
        <button type="button" data-testid={`${testid}-keep`} onClick={() => setAsk(false)} className="min-h-[40px] rounded-lg px-3 text-xs font-semibold text-slate-600">Keep</button>
      </div>
    );
  }
  return (
    <button type="button" data-testid={testid} disabled={!d} onClick={() => (f && f !== d ? setAsk(true) : copy())}
      className="inline-flex min-h-[40px] items-center gap-1.5 rounded-lg px-2 text-xs font-semibold text-blue-700 hover:bg-blue-50 disabled:opacity-40">
      <Copy className="h-3.5 w-3.5" /> Copy display name to first name
    </button>
  );
};
